
const m = window.require("showdown");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
